export enum EFieldType {
  Merge = 'Merge',
  Input = 'Input',
  Custom = 'Custom',
}

export enum EMergeCategory {
  None = 'None',
  Document = 'Document',
  Sender = 'Sender',
  Recipient = 'Recipient',
}

export enum EMergeKey {
  name = 'name',
  value = 'value',
  sendDate = 'sendDate',
  uniqueId = 'uniqueId',
  firstName = 'firstName',
  lastName = 'lastName',
  title = 'title',
  email = 'email',
  mobile = 'mobile',
  companyName = 'companyName',
  companyNumber = 'companyNumber',
}

export enum EMergeLabel {
  Name = 'Name',
  Value = 'Value',
  SendDate = 'Send date',
  UniqueId = 'Unique Id',
  FirstName = 'First name',
  LastName = 'Last name',
  Title = 'Title',
  Email = 'Email',
  Mobile = 'Mobile',
  CompanyName = 'Company name',
  OrganisationNumber = 'Org. number',
}
